import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './BusinessSection.styles';
import { Packages } from '@/components/Profile/Business/Packages';
import { Balance } from '@/components/Profile/Business/Balance';
import { Invoices } from '@/components/Profile/Business/Invoices';
import { HeaderNotification } from '@/components/Profile/Business/HeaderNotification';
import { Tab } from '@/components/Tabs/Tabs.types';
import { PendingInvoice } from '@/components/Profile/Business/PendingInvoice';

export const BusinessSection = () => {
  const { t } = useTranslation();
  const componentRefs = {
    packages: useRef<HTMLDivElement>(null),
    balance: useRef<HTMLDivElement>(null),
    invoices: useRef<HTMLDivElement>(null),
  };
  const [tabs, setTabs] = useState([
    {
      id: 1,
      label: t('pages.cabinet.packages'),
      value: 'packages',
      isActive: true,
    },
    {
      id: 2,
      label: t('pages.cabinet.balance'),
      value: 'balance',
      isActive: false,
    },
    {
      id: 2,
      label: t('pages.cabinet.invoices'),
      value: 'invoices',
      isActive: false,
    },
  ]);
  const [activeButton, setActiveButton] =
    useState<keyof typeof componentRefs>('packages');

  useEffect(() => {
    setTabs(prevTabs =>
      prevTabs.map(tab => ({ ...tab, isActive: activeButton === tab.value }))
    );
  }, [activeButton]);

  useEffect(() => {
    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting || entry.intersectionRatio > 0.1) {
          setActiveButton(entry.target.id as keyof typeof componentRefs);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.5,
    });

    if (componentRefs.packages.current) {
      observer.observe(componentRefs.packages.current);
    }
    if (componentRefs.balance.current) {
      observer.observe(componentRefs.balance.current);
    }
    if (componentRefs.invoices.current) {
      observer.observe(componentRefs.invoices.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  function scrollToComponent(name: keyof typeof componentRefs) {
    const target = componentRefs[name].current;
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }

  function onTabClick(tab: Tab) {
    scrollToComponent(tab.value as keyof typeof componentRefs);
  }

  return (
    <>
      <HeaderNotification />
      <S.HeaderTabs tabs={tabs} onTabCLick={onTabClick} shape="rounded" />
      <PendingInvoice />
      <Packages id="packages" ref={componentRefs.packages} />
      <Balance id="balance" ref={componentRefs.balance} />
      <Invoices id="invoices" ref={componentRefs.invoices} />
    </>
  );
};
